<template>
  <div
    class="page-plp_product__item"
    :class="{
      'page-plp_product_mobile__item': isMobile,
      'page-plp_product_mobile__item-hover': !isMobile
    }"
    :style="elementStyle"
  >
    <PdtCornerLabel abs-position :data="tagName" class="tag" style="z-index: 1" />
    <nuxt-link
      v-if="!isMobile"
      :to="{
        name: 'pdp',
        params: { code: activeData.productNo },
        query: {}
      }"
      target="_blank"
      :module_name="trackData.module_name"
      :module_rank="trackData.module_rank"
      :operation_name="trackData.operation_name"
      :operation_id="trackData.operation_id"
      :operation_rank="trackData.operation_rank"
      :destination_url="trackData.destination_url"
      click_type="商品"
      :event_name="trackData.event_name"
      :product_rank="trackData.product_rank"
      :primary_category="trackData.primary_category"
      :secondary_category="trackData.secondary_category"
      :third_category="trackData.third_category"
      :activity_attribute="JSON.stringify(trackData.activity_attribute)"
      :gender="trackData.gender"
      :spu_id="trackData.spu_id"
      :spu_name="trackData.spu_name"
      :sales_price="trackData.sales_price"
      :list_price="trackData.list_price"
      :exposure_sequence="trackData.exposure_sequence"
      :exposure_position="trackData.exposure_position"
      :navigation_primary_category="trackData.navigation_primary_category"
      :navigation_secondary_category="trackData.navigation_secondary_category"
      :navigation_third_category="trackData.navigation_third_category"
      :is_discount="String(trackData.is_discount)"
      :filter_content="JSON.stringify(trackData.filter_content)"
      :key_word="trackData.key_word"
      :key_word_type="trackData.key_word_type"
      :sku_name="trackData.sku_name"
      :sku_id="trackData.sku_id"
    >
      <div class="item__image-wraper">
        <UAImage
          aspect-ratio="4/5"
          class="item__image item__image-front"
          :src="displayImageList[0]"
          :alt="activeData.productName"
        />
        <UAImage
          v-if="defer(1) && displayImageList[1]"
          aspect-ratio="4/5"
          class="item__image item__image-back"
          :src="displayImageList[1]"
          :alt="activeData.productName"
        />
      </div>
    </nuxt-link>
    <div v-else>
      <van-swipe :show-indicators="false" @change="changeHandle">
        <nuxt-link
          v-for="(item, indexPro) in productList"
          :key="indexPro"
          :to="{
            name: 'pdp',
            params: { code: activeData.productNo },
            query: {}
          }"
          target="_blank"
          :module_name="trackData.module_name"
          :module_rank="trackData.module_rank"
          :operation_name="trackData.operation_name"
          :operation_id="trackData.operation_id"
          :operation_rank="trackData.operation_rank"
          :destination_url="trackData.destination_url"
          click_type="商品"
          :event_name="trackData.event_name"
          :product_rank="trackData.product_rank"
          :primary_category="trackData.primary_category"
          :secondary_category="trackData.secondary_category"
          :third_category="trackData.third_category"
          :activity_attribute="JSON.stringify(trackData.activity_attribute)"
          :gender="trackData.gender"
          :spu_id="trackData.spu_id"
          :spu_name="trackData.spu_name"
          :sales_price="trackData.sales_price"
          :list_price="trackData.list_price"
          :exposure_sequence="trackData.exposure_sequence"
          :exposure_position="trackData.exposure_position"
          :navigation_primary_category="trackData.navigation_primary_category"
          :navigation_secondary_category="trackData.navigation_secondary_category"
          :navigation_third_category="trackData.navigation_third_category"
          :is_discount="String(trackData.is_discount)"
          :filter_content="JSON.stringify(trackData.filter_content)"
          :key_word="trackData.key_word"
          :key_word_type="trackData.key_word_type"
          :sku_name="trackData.sku_name"
          :sku_id="trackData.sku_id"
        >
          <van-swipe-item>
            <UAImage
              aspect-ratio="4/5"
              :src="
                item && item.mediaLinkList && getUrlWithOss(item.mediaLinkList[0], { s: '0,818' })
              "
              :alt="item.productName"
            />
          </van-swipe-item>
        </nuxt-link>
      </van-swipe>
    </div>
    <div class="spu-list">
      <div v-if="!isMobile && defer(2)" class="hover-box">
        <GtSwiper
          v-if="spuColor.length > 1"
          :data="productList || []"
          :swiper-option="swiperOption"
          auto-button-display
        >
          <div slot="default" slot-scope="{ data }" class="swiper-detail">
            <nuxt-link
              :to="{
                name: 'pdp',
                params: { code: data.productNo },
                query: {}
              }"
              target="_blank"
              :module_name="trackData.module_name"
              :module_rank="trackData.module_rank"
              :operation_name="trackData.operation_name"
              :operation_id="trackData.operation_id"
              :operation_rank="trackData.operation_rank"
              :destination_url="trackData.destination_url"
              click_type="商品"
              :event_name="trackData.event_name"
              :product_rank="trackData.product_rank"
              :primary_category="trackData.primary_category"
              :secondary_category="trackData.secondary_category"
              :third_category="trackData.third_category"
              :activity_attribute="JSON.stringify(trackData.activity_attribute)"
              :gender="trackData.gender"
              :spu_id="trackData.spu_id"
              :spu_name="trackData.spu_name"
              :sales_price="trackData.sales_price"
              :list_price="trackData.list_price"
              :exposure_sequence="trackData.exposure_sequence"
              :exposure_position="trackData.exposure_position"
              :navigation_primary_category="trackData.navigation_primary_category"
              :navigation_secondary_category="trackData.navigation_secondary_category"
              :navigation_third_category="trackData.navigation_third_category"
              :is_discount="String(trackData.is_discount)"
              :filter_content="JSON.stringify(trackData.filter_content)"
              :key_word="trackData.key_word"
              :key_word_type="trackData.key_word_type"
              :sku_name="trackData.sku_name"
              :sku_id="trackData.sku_id"
            >
              <div @mouseenter.stop="handleSelectProduct(data)">
                <UAImage
                  :src="
                    data.mediaLinkList &&
                    data.mediaLinkList.length &&
                    getUrlWithOss(data.mediaLinkList[0])
                  "
                  :alt="data.productName"
                  aspect-ratio="4/5"
                />
                <!-- <span v-if="data.inStock === 0" class="out-of-stock">补货中</span> -->
                <div
                  v-if="activeData.productCode == data.productCode"
                  class="active-border-bottom-line"
                ></div>
              </div>
            </nuxt-link>
          </div>
          <div v-if="spuColor.length > 5" slot="pagination">
            <div class="swiper-button-prev">
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15 6L9 12L15 18"
                  stroke="#14141E"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
            <div class="swiper-button-next">
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9 18L15 12L9 6"
                  stroke="#14141E"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </div>
        </GtSwiper>
      </div>
      <div
        :style="{
          visibility: spuColor.length > 1 ? 'unset' : 'hidden'
        }"
        class="sp-plp-card__color"
        style="height: 8px"
      >
        <span v-for="(item, indexSpu) in spuColor" :key="indexSpu">
          <span
            v-if="indexSpu < 5"
            class="color-img"
            :src="item.valueImage"
            :alt="item.valueName"
            :style="{
              backgroundColor: item.valueImage || item.valueCode,
              border: ['#FFFFFF', 'white'].includes(item.valueImage || item.valueCode)
                ? '1px solid #dddddd'
                : '',
              width:
                item.valueCode == activeData.skuColor && indexSpu == activeData.skuColorIndex
                  ? isMobile
                    ? '16px'
                    : '32px'
                  : isMobile
                  ? '4px'
                  : '8px'
            }"
            :class="item.valueCode"
          />
        </span>
        <span v-if="spuColor.length > 5" class="color-block-dian">
          <svg
            v-for="item in 3"
            :key="item"
            xmlns="http://www.w3.org/2000/svg"
            width="4"
            height="4"
            viewBox="0 0 4 4"
            fill="none"
            style="margin-right: 4px"
          >
            <circle cx="2" cy="2.00098" r="2" fill="#B4B4BF" />
          </svg>
        </span>
      </div>
    </div>
    <div class="sp-plp-card__name">
      <p class="product-name one-line">
        {{ activeData.productName || data.productName }}
      </p>
    </div>

    <!-- TODO:等后端接口，分别处理 库存紧张、折扣、卖点、排行 数据  -->
    <div
      :style="{
        visibility: activeData ? 'unset' : 'hidden'
      }"
      class="promotion"
    >
      <template v-if="activeData">
        <div class="text-ellipsis" :class="productBottomLabelTypeMap[bottomTagName.type]">
          {{ bottomTagName.text }}
        </div>
      </template>
    </div>
    <div
      class="sp-plp-card__price"
      :class="{ no_flex: isShowFFSPriceFlag && getFFsPriceC.isShowFFSPrice }"
    >
      <UaPrice
        :flash-price="
          data.spuCampaign &&
          ['6001', '6000'].includes(data.spuCampaign.activityType) &&
          isLogin &&
          !isGuest
            ? data.spuCampaign.flashPrice
            : undefined
        "
        :show-ffs-price="
          isShowFFSPriceFlag &&
          getFFsPriceC.isShowFFSPrice &&
          !['home', 'LandingPage'].includes($route.name)
        "
        :ffs-price="getFFsPriceC.ffsPrice"
        :sale-price="activeData.salePrice"
        :product-price="activeData.productPrice"
      ></UaPrice>
    </div>
  </div>
</template>

<script>
import { GtSwiper, componentsCommon } from '@speedshop/template';
import UaPrice from './UaPrice.vue';
import UAImage from '@/components/UAImage/index.vue';
import ossImage from '@/mixins/ossImage';
import PdtCornerLabel from '@/components/PDP/PdtCornerLabel.vue';
import { getFFsPrice } from '@/utils/pdp';
import defer from '@/mixins/defer';

export default {
  components: { UAImage, GtSwiper, PdtCornerLabel, UaPrice },
  mixins: [componentsCommon, ossImage, defer()],
  props: {
    data: {
      type: Object
    },
    hasAd: {
      type: Boolean,
      default: false
    },
    index: {
      type: Number,
      default: 0
    },
    dataList: {
      type: Array,
      default: () => []
    },
    trackDataNav: {},
    selectedList: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      swiperOption: {
        spaceBetween: 8,
        // slidesPerView: 3, // 不使用，滑动无边界
        slidesPerView: 'auto', // 不使用，滑动无边界
        // threshold: 20,
        freeMode: {
          enabled: false
          // momentumBounce: false,
          // sticky: false
        },
        // 设置点击箭头
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      activeData: {},
      showLogin: false,
      activeImgIndex: 0,
      istwoline: false,
      // thumbnailNum: 4, // 缩略图一行最小几个
      productBottomLabelTypeMap: {
        '01': '',
        '02': 'sp-plp-card__promotion',
        '03': 'sp-plp-card__selling'
      },
      isShowFFSPriceFlag: false
    };
  },
  computed: {
    activityContent() {
      const res = (this.activeData && this.activeData.productActivities).reduce((pre, cur) => {
        if (pre) {
          return `${pre}    ${cur.activityName}`;
        } else {
          return `${cur.activityName}`;
        }
      }, '');
      return res;
    },
    trackData() {
      // exposure_sequence 1
      const { index, trackDataNav } = this;
      const count = this.isMobile ? 2 : 4;
      const {
        navigation_primary_category,
        navigation_secondary_category,
        navigation_third_category
      } = trackDataNav;

      const exposureSequence =
        !this.isMobile && this.hasAd
          ? Math.ceil((index + 3) / count)
          : this.isMobile && this.hasAd
          ? Math.ceil((index + 2) / count)
          : Math.ceil((index + 1) / count);
      const exposurePosition =
        !this.isMobile && this.hasAd
          ? (index + 3) % count
          : this.isMobile && this.hasAd
          ? (index + 2) % count
          : (index + 1) % count;

      const previousPageData = this.$previousPage.getPreviousPageData();

      return {
        ...previousPageData,
        navigation_primary_category,
        navigation_secondary_category,
        navigation_third_category,
        exposure_sequence: exposureSequence, // 上下
        exposure_position: exposurePosition || count, // 左右
        ...this.activeData.trackData,
        event_name: this.$route.name === 'plpSearch' ? 'reseachResultClick' : 'productListClick',
        sku_id: this.activeData.productNo,
        sku_name: this.activeData.productName,
        key_word: this.$route.query.searchWord,
        key_word_type: '主动搜索',
        filter_content: this.selectedList.map(i => i?.name),
        spu_id:
          this.$route.name === 'plpSearch'
            ? this.activeData.mainProductNo
            : this.activeData.productNo
      };
    },
    productList() {
      console.log(this.data, 'this.data');
      let { productList = [], spuColor = [] } = this.data;
      if (['home', 'LandingPage', 'LandingPage-all'].includes(this.$route.name)) {
        productList = this.isMobile ? [{ ...this.data }] : productList;
      }
      const list = productList.map((item, index) => {
        if (!Object.prototype.hasOwnProperty.call(item, 'isWished')) {
          // 如果对象没有 'isWished' 属性，就给它添加
          item.isWished = false;
        }
        const { mediaLink = '', mobileMediaLink = '', ...others } = item;

        const mobileMediaLinkList = (mobileMediaLink || mediaLink || '')
          .replace(/,http/g, '[http')
          .split('[');

        const mediaLinkList = (mediaLink || mobileMediaLink || '')
          .replace(/,http/g, '[http')
          .split('[');
        return {
          mediaLinkList: this.isMobile
            ? mobileMediaLinkList || mediaLink
            : mediaLinkList || mobileMediaLinkList,
          skuColor: spuColor && spuColor[index] ? spuColor[index]?.valueCode : null,
          skuColorIndex: spuColor && spuColor[index] ? index : null,
          ...others
        };
      });
      // fix
      // const filterOutStock = list.filter(item => item.inStock !== 0);
      const filterOutStock = list;
      return filterOutStock;
    },
    spuColor() {
      return this.data.spuColor || [];
    },
    tagList() {
      return this.data.mainTagList || [];
    },
    tagName() {
      return this.activeData.productCornerLabel || { text: '' };
      // return { text: '新品' };
    },
    bottomTagName() {
      const bottomLabels = this.activeData.productBottomLabels;
      if (bottomLabels && bottomLabels.length > 0) {
        return {
          type: bottomLabels[0].type,
          text: bottomLabels
            .map(ele => {
              return ele.text;
            })
            .join('\u00A0\u00A0')
        };
      } else {
        return {
          type: undefined,
          text: ''
        };
      }
    },
    elementStyle() {
      let paddingValue = 0;
      if (!this.isMobile) {
        paddingValue = 32;
      }
      return {
        'padding-bottom': `${paddingValue}px`
      };
    },
    getFFsPriceC() {
      return getFFsPrice(this.activeData);
    },
    displayImageList() {
      return this.activeData.mediaLinkList?.filter(i => !this.isVideoType(i)) || [];
    }
  },
  watch: {
    data: {
      handler(val) {
        this.activeData = val;
        // this.isWished = this.data.isWished;
      },
      deep: true
    }
  },
  mounted() {
    this.activeData = this.data;
    this.activeData.skuColor = this.data.spuColor && this.data.spuColor[0]?.valueCode;
    this.activeData.skuColorIndex = 0;

    // if (!this.isMobile) {
    //   this.listenerProductName();
    // }
    this.isShowFFSPriceFlag = localStorage.getItem('showFFSPrice') === 'true';
  },
  methods: {
    handleSelectProduct(data) {
      if (data.productCode === this.activeData.productCode) return;
      this.activeData = data;
    },
    isVideoType(url) {
      const urlObj = new URL(url.trim());
      const fileExtension = urlObj.pathname.split('?')[0].split('.').pop();
      return ['mp4', 'avi', 'mov', 'wmv'].includes(fileExtension);
    },
    // listenerProductName() {
    //   const productName = document.getElementById('product-name-id-' + this.index);
    //   const previousHeight = productName?.clientHeight;
    //   if (previousHeight === 44) {
    //     this.istwoline = true;
    //   }
    //   // 获取并计算，swiper的单行显示spucolor个数
    //   const parent = document.getElementById('hover-box-id-' + this.index);
    //   if (parent) {
    //     const childElement = parent.querySelector('.sp-swiper-container');
    //     if (childElement) {
    //       const childWidth = childElement.clientWidth;
    //       // 计算区间最小整数值
    //       function findSmallestX(y) {
    //         const x1 = Math.ceil(y / 56); // 因为缩略图width固定56px
    //         const x2 = Math.ceil((y > 56 ? y - 56 : y) / 56);
    //         return Math.min(x1, x2);
    //       }
    //       this.thumbnailNum = findSmallestX(childWidth) || 4;
    //       // this.$set(this.swiperOption, 'slidesPerView', this.thumbnailNum - 1);
    //       // 如果当前颜色数目未超过一行，没有颜色缩略图左右边距
    //       // if (this.spuColor.length < this.thumbnailNum) {
    //       //   childElement.style.paddingLeft = '0px';
    //       //   childElement.style.paddingRight = '0px';
    //       // }
    //     }
    //   }
    // },
    changeHandle(current) {
      this.$nextTick(() => {
        this.activeData = this.productList[current];
      });
    },
    handleLinkClick() {
      // 阻止默认导航行为
      // event.preventDefault();
      const code = this.activeData.productNo; // 获取需要传递的参数
      const url = this.$router.resolve({ name: 'pdp', params: { code } }).href;
      window.open(url, '_blank'); // 打开新的浏览器标签页
    }
  }
};
</script>

<style lang="scss" layout="pc">
.page-plp_product__item {
  min-height: 100%;
  border: 1px solid #fff;
  cursor: pointer;
  -webkit-touch-callout: none !important;
  /* 标准属性 */
  user-select: none;

  /* 为了兼容性添加各个浏览器的前缀 */
  -webkit-user-select: none; /* Safari 和 Chrome */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  -o-user-select: none; /* Opera */

  // .gt-image-container > div:first-child {
  //   transition: 1s all; //todo
  // }
  .item__image-wraper {
    position: relative;
    .lp-item__image {
    }
    .item__image-back {
      opacity: 0;
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
    }
    &:hover .item__image-back {
      opacity: 1;
    }
  }
  &:hover {
    .spu-list .hover-box {
      visibility: visible;
      transition: 0.5s all;
    }

    .wish-icon {
      display: block;
    }
  }

  .wish-icon {
    width: 20px;
    height: 20px;
    position: absolute;
    right: 26px;
    top: 26px;
    display: none;
    cursor: pointer;
    z-index: 2;
  }

  .tag {
    position: absolute;
    left: 12px;
    top: 12px;

    z-index: 10;
  }

  .cancel-message {
    position: fixed;
    top: 50%;
    left: 50%;
    line-height: 22px;
    text-align: center;
    background: var(--darkgrey-60, rgba(20, 20, 30, 0.6));
    color: #fff;
    z-index: 9;
    transform: translate(-50%, -50%);
    border-radius: 1px;
    opacity: 0;
    display: none;
    padding: 12px 24px;
    gap: 12px;
    &.show {
      opacity: 1;
      display: block;
    }

    transition: all 0.5s;
  }

  .spu-list {
    // position: relative;
    // padding: 0px 30px 0px 12px;
    z-index: 1;
    position: relative;

    .hover-box {
      visibility: hidden;
      position: absolute;
      left: -11px;
      right: -11px;
      // top: 0px;
      bottom: -2px;
      padding: 0px 11px 0;
      // border-left: 1px solid var(--border-color-default);
      // border-right: 1px solid var(--border-color-default);
      // border-bottom: 1px solid var(--border-color-default);
      background: #fff;
      overflow: hidden;

      .sp-swiper-container {
        position: relative;
        // padding: 8px 16px;
        padding-left: 24px;
        padding-right: 24px;
        padding-top: 8px;
        padding-bottom: 8px;
        overflow: hidden;
        height: 86px;

        .swiper-wrapper {
          .swiper-slide {
            width: 56px !important;
            position: relative;
            cursor: pointer;
            // margin-right: 0 !important;
            // margin-left: 8px !important;

            .out-of-stock {
              background: rgba(240, 240, 240, 0.8);
              display: flex;
              align-items: center;
              justify-content: center;
              position: absolute;
              left: 0;
              right: 0;
              top: 0;
              bottom: 0;
              color: var(--main-color-ua-red, #dc0019);
              font-size: 14px;
              font-weight: 400;
              line-height: 20px;
            }
          }
        }
      }
      .active-border-bottom-line {
        border-bottom: 2px solid var(--main-color-ua-red, #dc0019);
        width: 100%;
        position: absolute;
        bottom: 0px;
      }
    }

    .swiper-button-prev,
    .swiper-button-next {
      background-color: rgba(0, 0, 0, 0);
      width: 16px;
      height: 16px;
      margin: -8px;
      padding-top: 12px;
      transition: none;
      &.swiper-button-disabled {
        display: none;
      }

      svg {
        width: 0px;
        // height: 16px;
      }

      &::after {
        color: var(--font-color-primary);
        font-size: 14px;
      }
    }

    .swiper-button-disabled {
      svg {
        opacity: 0.4;
      }

      display: flex;
    }
  }

  .sp-plp-card__color {
    display: flex;
    align-items: center;
    margin-top: 20px;
    margin-bottom: 16px;
    justify-content: center;
    .color-img {
      width: 8px;
      height: 8px;
      margin-right: 6px;
      display: block;

      &.white {
        border: 1px #979797 solid;
      }
    }

    span {
      color: var(--secondary-color-ua-cool-grey-04, #50505a);
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 18px;
    }
  }

  .sp-plp-card__name {
    font-size: 14px;
    font-weight: 600;
    color: var(--font-color-primary);
    line-height: 20px;
    margin: 0px 0px 8px 0;
    height: 40px;
    display: flex;
    align-items: flex-end;
    .product-name {
      -webkit-line-clamp: 2;
      max-height: 46px;
      // height: 46px;
      line-height: 22px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      font-weight: 400;
      font-style: normal;
      font-family: PingFang SC;
      color: var(--main-color-ua-dark-grey, #14141e);
      font-size: 16px;

      &.one-line {
        -webkit-line-clamp: 1;
        height: 22px;
      }
    }
  }

  .sp-plp-card__price {
    display: block;
    color: var(--secondary-color-ua-cool-grey-03, #8c8c96);
    font-family: Neue Plak;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;

    .product-price {
      text-decoration: line-through !important;
      // opacity: 0.5;
      margin: 0px 8px;
    }
    .is-line-through {
      color: var(--main-color-ua-dark-grey, #14141e);
    }
  }

  .promotion {
    align-items: center;
    flex-wrap: wrap;
    height: 20px;
    margin-bottom: 8px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    -webkit-line-clamp: 1;
    color: var(--main-color-ua-red, #dc0019);
    .sp-plp-card__promotion {
      color: var(--main-color-ua-red, #dc0019);
      font-family: PingFang SC;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px; /* 142.857% */
      text-transform: capitalize;
    }
    .sp-plp-card__selling {
      color: var(--secondary-color-ua-cool-grey-03, #8c8c96);

      /* cn/pingfang/regular/14 */
      font-family: PingFang SC;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px; /* 142.857% */
      text-transform: capitalize;
    }
    span {
      font-size: 14px;
      color: #dc0019;
      border-radius: 1px;
      line-height: 20px;
      height: 20px;
      margin-left: 12px;
      &:first {
        margin-left: 0;
      }
      //  display: block;

      // max-width: 76px;
      // display: block;
      // -webkit-line-clamp: 1;
      // overflow: hidden;
      // text-overflow: ellipsis;
      // -webkit-box-orient: vertical;
      &.promotion-item-1 {
        max-width: 100% !important;
      }
      &.has-num {
        max-width: 71px;
      }
      &.no-first {
        margin-left: 12px;
      }
    }
  }
  .color-block-dian {
    line-height: 8px;
    svg {
      margin-right: 4px;
      height: 4px;
      width: 4px;
    }
  }
  .ua-image {
    background: #f0f0f0;
  }
  .text-ellipsis {
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.sp-plp-page {
  .page-plp_product__item .spu-list .swiper-button-next {
    width: 24px;
    height: 100%;
    background: #fff;
    z-index: 1;
    opacity: 1;
    border-radius: 0;
    top: 50%;
    transform: translateY(-50%);
    padding: 0;
    margin: 0px;
    right: 0;
    justify-content: flex-end;

    svg {
      top: 50%;
      margin-top: 12px;
      transform: translateY(-50%);
    }
  }

  .page-plp_product__item .spu-list .swiper-button-prev {
    width: 24px;
    height: 100%;
    background: #fff;
    z-index: 1;
    opacity: 1;
    border-radius: 0;
    top: 50%;
    transform: translateY(-50%);
    padding: 0;
    margin: 0px;
    left: 0;
    justify-content: flex-start;

    svg {
      top: 50%;
      margin-top: 12px;
      transform: translateY(-50%);
    }
  }
  .one-img:hover img {
    transition: transform 0.7s ease;
    transform: scale(1.1);
  }
  .mobile-press-mask {
    flex-direction: column; /* 垂直排列元素 */

    align-items: center;
    background: var(--darkgrey-60, rgba(20, 20, 30, 0.6));
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    text-align: center;
    color: white; /* 遮罩层上的文字颜色 */
    display: flex;
    padding: 16px 0 20px;
    z-index: 10;
    .mpm-title {
      color: var(--main-color-ua-white, #fff);
      text-align: center;

      /* cn/pingfang/regular/12 */
      font-family: PingFang SC;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 18px; /* 150% */
      text-transform: capitalize;
    }
    .mpm-circle {
      width: 48px;
      height: 48px;
      flex-shrink: 0;
      fill: var(--white-30, rgba(255, 255, 255, 0.3));
      backdrop-filter: blur(10px);
      margin-top: 31px;
      position: relative;
      .mpm-circle-svg {
        width: 48px;
        height: 48px;
        flex-shrink: 0;
      }
      .mpm-circle-icon-svg {
        width: 24px;
        height: 24px;
        position: absolute;
        left: 12px;
        top: 12px;
      }
      .circle-button {
        position: absolute;
        width: 100%;
        left: 0;
        top: 60px;
        color: var(--main-color-ua-white, #fff);
        text-align: center;

        /* cn/pingfang/regular/14 */
        font-family: PingFang SC;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px; /* 142.857% */
        text-transform: capitalize;
      }
    }
    .circle-button-2 {
      position: absolute;
      bottom: 20px;
      color: var(--main-color-ua-white, #fff);
      text-align: center;

      /* cn/pingfang/bold/12 */
      font-family: PingFang SC;
      font-size: 12px;
      font-style: normal;
      font-weight: 600;
      text-transform: uppercase;
      height: 28px;
      border: 0.5px solid var(--main-color-ua-white, #fff);
      line-height: 28px;
      padding: 0 12px;
      border-radius: 1px;
    }
  }
  .mobile-press-mask2 {
    flex-direction: column;
    align-items: center;
    background: var(--darkgrey-60, rgba(20, 20, 30, 0.6));
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    text-align: center;
    color: white; /* 遮罩层上的文字颜色 */
    display: flex;
    justify-content: center;

    .mpm-circle {
      width: 48px;
      height: 48px;
      fill: var(--white-30, rgba(255, 255, 255, 0.3));
      backdrop-filter: blur(10px);
      position: relative;
      .mpm-circle-svg {
        width: 48px;
        height: 48px;
        flex-shrink: 0;
      }
      .mpm-circle-icon-svg {
        width: 24px;
        height: 24px;
        position: absolute;
        left: 12px;
        top: 12px;
      }
      .circle-button {
        position: absolute;
        width: 100%;
        left: 0;
        top: 60px;
        color: var(--main-color-ua-white, #fff);
        text-align: center;

        /* cn/pingfang/regular/14 */
        font-family: PingFang SC;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px; /* 142.857% */
        text-transform: capitalize;
      }
    }
  }
}
</style>
<style lang="scss" layout="mobile">
.page-layout_mobile {
  .product-list-columns-3 {
    .page-plp_product__item {
      .sp-plp-card__color {
        span {
          &:nth-child(3) {
            display: none;
          }
          &:nth-child(4) {
            display: none;
          }
        }
      }
    }
  }
  .page-plp_product__item {
    padding: 0px 0px 14px 0px;
    border: 0px;
    cursor: pointer;
    .ua-corner-lb {
      transform: scale(0.8);
      transform-origin: top left; /* 将变换原点设置为左上角 */
    }
    &:hover {
      border: 0px;
    }
    .sp-plp-card__color {
      display: flex;
      align-items: center;
      margin-top: 12px;
      margin-bottom: 12px;
      justify-content: center;
      padding: 0px 16px;
      .color-img {
        height: 4px;
        margin-right: 4px;

        &.white {
          border: 1px #979797 solid;
        }
      }

      span {
        color: var(--secondary-color-ua-cool-grey-04, #50505a);
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 18px;
      }
    }
    .sp-plp-card__name,
    .sp-plp-card__price,
    .sp-lp-card__final-price,
    .promotion {
      padding: 0px 16px;
      span {
        // padding: 0px 4px;
        max-width: 70px;
        &.promotion-item-1 {
          max-width: 100%;
        }
        &.has-num {
          max-width: 62px;
        }
      }
    }

    .sp-plp-card__name {
      margin-bottom: 8px;

      .product-name {
        -webkit-line-clamp: 2;
        max-height: 36px;
        line-height: 18px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        font-family: PingFang SC;
        color: var(--main-color-ua-dark-grey, #14141e);

        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        text-transform: capitalize;
        height: 36px;
      }
    }
    .promotion {
      height: 18px;
      line-height: 18px;
      .sp-plp-card__promotion {
        color: var(--main-color-ua-red, #dc0019);
        font-family: PingFang SC;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 18px; /* 150% */
        text-transform: capitalize;
      }
      .sp-plp-card__selling {
        color: var(--secondary-color-ua-cool-grey-03, #8c8c96);
        font-family: PingFang SC;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 18px; /* 150% */
        text-transform: capitalize;
      }
      span {
        font-size: 12px;
        color: #dc0019;
        border-radius: 1px;
        line-height: 18px;
        height: 18px;
        //  max-width: 76px;
        display: block;
        -webkit-line-clamp: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-box-orient: vertical;
        &.promotion-item-1 {
          max-width: 100% !important;
        }
        &.has-num {
          max-width: 71px;
        }
        &.no-first {
          margin-left: 8px;
        }
      }
    }
    .sp-plp-card__price {
      line-height: 18px;
      height: 18px;
      margin-bottom: 28px;

      color: var(--secondary-color-ua-cool-grey-03, #8c8c96);
      font-family: Neue Plak;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      span {
        padding: 0px;
      }
      .product-price {
        margin-left: 4px;
      }
    }

    .wish-icon {
      right: 8px;
      top: 8px;
      display: block;
    }

    .tag {
      left: 8px;
      top: 8px;
      font-size: 12px;
    }

    .cancel-message {
      position: fixed;
    }
    .color-block-dian {
      line-height: 4px !important;
      svg {
        margin-right: 2px !important;
        height: 2px;
        width: 2px;
      }
    }
    .text-ellipsis {
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .no_flex {
      // display: block;
      padding: unset;
    }
  }
}
</style>
